// src/components/common/RecurringScheduleStatusBadge.js  recinv-badge-3e8b1d52
import React from 'react';

// Lifecycle status of a recurring-invoice schedule (active/paused/ended). Mirrors
// InvoiceStatusBadge EXACTLY, including the border-from-fill replace() convention.
// Health (broken / overdue / ending soon) is a SEPARATE axis shown with icons, not
// folded in here — same split as invoice status vs qbPushState.
const RecurringScheduleStatusBadge = ({ status }) => {
    const styles = {
        active: 'bg-green-100 text-green-800',
        paused: 'bg-yellow-100 text-yellow-800',
        ended: 'bg-gray-200 text-gray-600',
    };

    const normalizeStatus = status ? status.toLowerCase() : 'active';
    const styleClass = styles[normalizeStatus] || 'bg-gray-100 text-gray-800';
    const label = status ? status.charAt(0).toUpperCase() + status.slice(1) : 'Unknown';

    return (
        <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium border ${styleClass.replace('text-', 'border-').replace('100', '200')} ${styleClass}`}>
            {label}
        </span>
    );
};

export default RecurringScheduleStatusBadge;
